export const PHONE_REQUIRED_LENGTH = 11;

export const EMPTY_ANSWER_ERROR = 'Пожалуйста, выберите один из вариантов';
export const PHONE_LENGTH_ERROR = 'Пожалуйста, введите корректный номер телефона';
export const INCORRECT_PHONE_ERROR = 'Пожалуйста, введите корректный номер телефона';
export const EMPTY_PHONE_ERROR = 'Необходимо указать номер телефона';
export const AGREEMENT_ERROR = 'Необходимо согласиться с политикой конфиденциальности';

export const CLOSE_WITH_ERROR = 'get_error'
export const EVENT_DEFINE_SERVICE = 'define_service';
export const EVENT_CHOOSE_SERVICE = 'choose_service';
export const EVENT_GET_LEAD = 'get_lead';
export const EVENT_GET_APPOINTMENT = 'get_appointment';
export const EVENT_LOAD_QUIZ = 'load_quiz';
export const EVENT_LOAD_CONTENT = "load_content";
export const EVENT_CLOSE_QUIZ = 'close';
export const EVENT_OPEN_QUIZ = 'open';
export const EVENT_START_QUIZ = 'start_quiz';
export const EVENT_START_QUIZ_COMMON = 'start_quiz_0';
export const EVENT_REACH_PHONE_FORM = 'reach_phone_form';
export const EVENT_START_TYPING_PHONE = 'start_typing_phone';
export const EVENT_CLICK_TRADEMARK = 'click_trademark';
export const EVENT_CLICK_HEADER_PHONE = 'click_header_phone';
export const EVENT_GET_CLIENT_INFO = 'get_client_info';
export const EVENT_RICH_QUESTION = 'reach_question';
export const EVENT_DEFINE_AB_TEST_CASE = 'define_ab_test_case';
export const EVENT_GET_CALL_TIME = 'get_call_time';
export const EVENT_SHOW_FLYING_BTN = 'show_flying_btn';
export const EVENT_START_BY_FLYING_BTN = 'start_by_flying_btn';
export const EVENT_START_BY_TIMER = 'start_by_timer';
export const EVENT_START_BY_MAIN_BUTTON = 'start_by_main_button';
export const EVENT_OPEN_SIGN_UP_BY_TIMER = 'open_sign_up_by_timer';
export const EVENT_NEXT_BY_SCROLL = 'start_by_scroll';
export const EVENT_CLICK_ADDITIONAL_BUTTON = 'click_additional_button';
export const EVENT_CLICK_WHATSAPP_BUTTON = 'click_whatsapp_button';
export const SEND_PARAMS = 'send_params';
export const EVENT_SHOW_PHONE_FORM_VISUAL = 'show_phone_form_visual';
export const EVENT_GO_TO_SERVICE_SELECTION = 'go_to_service_selection';
export const EVENT_CLICK_AGREEMENT = 'click_agreement';
export const EVENT_CUSTOM_CONTENT_ADD = 'custom_content_add';
export const EVENT_CLICK_POLICY_AGREE = 'click_policy_agree';
export const GET_ECOMMERCE_ACTION = 'get_ecommerce_action';

// export const SERVER_HOST = process.env.NODE_ENV == 'production' ? 'https://api.reserve-donkin-leads.ru/dentolo/v2' : 'http://localhost:8000';
// export const SERVER_HOST = process.env.NODE_ENV == 'production' ? 'https://api.reserve-donkin-leads.ru/' : 'https://api.donkin-leads.ru/dentolo/v2/';
export const SERVER_HOST = '';
// export const SERVER_HOST = 'https://api.donkin-leads.ru/dentolo/v2/';

export const AB_TEST_CALL_TIME = 'call_time';
export const AB_TEST_FORM_HEADER_TEXT = 'form_header_text';
export const AB_TEST_FORM_BUTTON_TEXT = 'form_button_text';
export const AB_TEST_FORM_FIELDS_STRUCT = 'form_fields_struct';
export const AB_TEST_FORM_VISUAL = 'phone_form_visual';
export const AB_TEST_BONUSES = 'bonuses';
export const AB_TEST_COMMON_SERVICE_LIST = 'commmon-service-list';
export const AB_TEST_PHONE_PLACEHOLDER = 'phone-placeholder';


export const DEMO_CLIENT_ID = "5e27e579281b08165e9a85c9"; //demo
// export const DEMO_CLIENT_ID = "60fe785a17611817bd4f3be5"; //denta-keller
// export const DEMO_CLIENT_ID = "5f606991fae3457d29e57fb9"; //demo
// export const DEMO_CLIENT_ID = "5eb90a88f7eeba3ae779793b"; //for_test_only
// export const DEMO_CLIENT_ID = "5f5b0c6de02aa90760317198"; //test_whatsapp
// export const DEMO_CLIENT_ID = "63c64d41f6466c02bd92d8ff"; //доктор шувалов
// export const DEMO_CLIENT_ID = "5f16ea9be8d20619444e12b3"; //все свои (мск)
// export const DEMO_CLIENT_ID = "5e5e53e851a7b017b1ef83c5"; //lider-dent26.ru

export const CALC_LINK = 'https://calc.donkin-leads.ru';
export const OUR_SITE_LINK = 'https://dentolo.ru';